import { reportSlugs } from '@app/ccf/company-report/slugs';
import ReportContent from '@app/components/reports/components/report-content';
import ReportMetric from '@app/components/reports/components/report-metric';
import SimpleBarChart from '@shared/components/chart/simple-bar-chart';
import Text from '@shared/components/content/text';
import { ChartConfig } from '@shared/components/ui/chart';
import { useCCFReportResult } from '../../ccf-report-result-context';

export default function DirectGasEmissions() {
  const {
    result: { scope1 },
  } = useCCFReportResult();

  const DirectGasEmissions = scope1.categories.find(
    (category) => category.slug === reportSlugs.directGasEmissions
  );

  const data = {
    direct_gas_emissions: DirectGasEmissions?.totalCategoryEmissionsTonnes,
    share_of_scope_emissions: DirectGasEmissions?.pctOfScopeEmissions,
    share_of_total_emissions: DirectGasEmissions?.pctOfCompanyEmissions,
    highest_emissions_fuels: DirectGasEmissions?.highestEmissionActivities.map(
      (fuel) => {
        return {
          fuel: fuel.name,
          emissions: fuel.emissionsTonnes,
          fill: 'var(--chart-3)',
        };
      }
    ),
  };

  const chartConfig = {
    emissions: {
      label: 'Emissions',
      color: 'hsl(var(--chart-1))',
      unit: 'tCO2e',
    },
  } satisfies ChartConfig;

  return (
    <ReportContent>
      <>
        <Text variant="reportBody">
          Direct gas emissions come from the use and leakage of specific gases
          during business operations. These emissions are categorised as Scope 1
          because they are directly produced by your business activities.
        </Text>
        <ReportMetric
          title="Category emissions"
          value={data.direct_gas_emissions!}
          unit="tCO2e"
          size="lg"
        />
        <div className="flex space-x-2">
          <ReportMetric
            title="Share of Scope 1 emissions"
            value={data.share_of_scope_emissions!}
            unit="%"
            size="md"
            className="flex-1"
          />
          <ReportMetric
            title="Share of total emissions"
            value={data.share_of_total_emissions!}
            unit="%"
            size="md"
            className="flex-1"
          />
        </div>
      </>
      <>
        <Text variant="h3">Highest emissions gases</Text>
        <SimpleBarChart
          nameKey="fuel"
          dataKey="emissions"
          chartData={data.highest_emissions_fuels}
          chartConfig={chartConfig}
          className="h-min max-h-[calc(var(--content-title-height)-10rem)] w-full"
          layout="vertical"
        />
      </>
    </ReportContent>
  );
}
